export default {
  SLUG: 'ws-navigation',
};
